import React from 'react';

const IntelligentAnalysisReports: React.FC = () => {
  return (
    <div style={{ width: '100%', height: '100vh', padding: '0', margin: '0' }}>
      <iframe
        src="https://autoreport.lab126.amazon.dev/"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        title="Intelligent Analysis Reports"
        allow="fullscreen"
      />
    </div>
  );
};

export default IntelligentAnalysisReports;
